import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// import components
import Header from './../../shared/components/Header'

// import styles
import './tasks.scss'

// Actions
import { getTasks } from './../../actions/tasks'

// Utils
import { renderFullDate } from '../../utils/time'
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission } from '../../utils/auth'
import { ElementIcons } from '../../shared/elements/icons'

// Elements
import Check from '../../shared/elements/check'
import Text from '../../shared/elements/text'
// import Inline from '../../shared/elements/inline'
import TableRow from '../../shared/elements/tableRow'
import Row from '../../shared/elements/row'
import Icon from '../../shared/elements/icon'
import PageHeader from '../../shared/elements/pageHeader'
import Grid from '../../shared/elements/grid'
import TableContainer from '../../shared/elements/tableContainer'
import Button from '../../shared/elements/button'
import Inline from '../../shared/elements/inline'

class Tasks extends Component {
  constructor (props) {
    super(props)
    this.state = {
      Tasks: [],
      searchTask: {
        CompanyId: null,
        ChainId: null,
        Name: '',
        IsFinished: false,
        Active: true,
        Inactive: false
      },
      IsMobile: false
    }
    this.handleResize = this.handleResize.bind(this)
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.listMenu = this.listMenu.bind(this)
    this.getTasks = this.getTasks.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount () {
    this.setState({
      IsMobile: window.outerWidth < 650,
      searchTask: {
        ...this.state.searchTask,
        CompanyId: Number(this.props.auth.user.ShopId)
      }
    })
    this.getTasks()

    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize () {
    const IsMobile = window.outerWidth < 650
    if (IsMobile !== this.state.IsMobile) {
      this.setState({
        IsMobile
      })
    }
  }

  renderHeaderTitle () {
    return translation('1227')
  }

  onChange (e) {
    var value = e.target.value
    if (value === undefined || value === 'on' || e.target.type === 'checkbox') {
      value = e.target.checked
    }

    this.setState({
      searchTask: {
        ...this.state.searchTask,
        [e.target.name]: value
      }
    }, () => this.getTasks())
  }

  getTasks () {
    this.props.getTasks(this.state.searchTask).then((res) => {
      this.setState({
        Tasks: res.data
      })
    })
  }

  // <Link to='/tasks/0'></Link>

  headerButtonsRight () {
    return (
      <div>
        <Button spacing={0} size='m' ariaText={translation('2056')} labelText={translation(1797)} onClick={() => { this.props.router.push('/tasks/0') }} />
      </div>
    )
  }

  listMenu () {
    return (
      <PageHeader>
        <Grid>
          <Text size='s' className='searchInput' name='Name' onChange={this.onChange} value={this.state.searchTask.Name} />
          <Check labelText={translation('295')} id='Active' name='Active' onChange={this.onChange} checked={this.state.searchTask.Active} />
          <Check labelText={translation('296')} id='Inactive' name='Inactive' onChange={this.onChange} checked={this.state.searchTask.Inactive} />
          <Check labelText={translation('23')} id='IsFinished' name='IsFinished' onChange={this.onChange} checked={this.state.searchTask.IsFinished} />
        </Grid>
      </PageHeader>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null
    const renderHeader = () => {
      return (
        <TableRow header>
          <span>{translation('30')}</span>
          <span>{translation('1232')}</span>
          <span>{translation('13516')}</span>
          <span>{translation('15071')}</span>
          <span>{translation('1230')}</span>
          <span>{translation('13052')}</span>
        </TableRow>
      )
    }
    const tasksList = (val, key) => {
      let tasksLink = '/tasks/' + val.OtherTaskId
      let status = val.IsActive ? val.IsFinished ? '1231' : '295' : '296'

      const renderInner = () => {
        return ([
          <div key={'Name'}>{val.Name}</div>,
          <div key={'Deadline'}>{renderFullDate(val.NextDeadline, false)}</div>,
          <div key={'endDate'}>{val.EndDate ? renderFullDate(val.EndDate, false) : <Icon icon={ElementIcons.Infinity} />}</div>,
          <div key={'Occurrences'}>{val.TotalOccurrences === null ? <Icon icon={ElementIcons.Infinity} /> : val.TotalOccurrences}</div>,
          <div key={'Category'}>{translation(val.CategoryName)}</div>,
          <div key={'Status'}>{translation(status)}</div>
        ])
      }

      if (this.state.IsMobile) {
        return (
          <Link to={tasksLink} className='task__link' key={key}>
            <div>{translation('30') + ': '}{val.Name}</div>
            <div>{translation('1232') + ': '}{renderFullDate(val.NextDeadline, false)}</div>
            <Inline spacing={0} block>{translation('13516') + ': '}{val.EndDate ? renderFullDate(val.EndDate, false) : <Icon icon={ElementIcons.Infinity} />}</Inline>
            <Inline spacing={0} block>{translation('15071') + ': '}{val.TotalOccurrences === null ? <Icon icon={ElementIcons.Infinity} /> : val.TotalOccurrences}</Inline>
            <div>{translation('1230') + ': '}{translation(val.CategoryName)}</div>
            <div>{translation('13052') + ': '}{translation(status)}</div>
          </Link>
        )
      }

      return (
        <Link to={tasksLink} className='task__link' key={key}>
          <TableRow>
            {renderInner()}
          </TableRow>
        </Link>
      )
    }
    return (
      <div className='tasks__screen'>
        <Header router={this.props.router} renderRight={this.headerButtonsRight} >
          <Grid align='center'>
            <Text size='s' className='searchInput' name='Name' onChange={this.onChange} value={this.state.searchTask.Name} />
            <Check labelText={translation('295')} id='Active' name='Active' onChange={this.onChange} checked={this.state.searchTask.Active} />
            <Check labelText={translation('296')} id='Inactive' name='Inactive' onChange={this.onChange} checked={this.state.searchTask.Inactive} />
            <Check labelText={translation('23')} id='IsFinished' name='IsFinished' onChange={this.onChange} checked={this.state.searchTask.IsFinished} />
          </Grid>
        </Header>
        <Row>
          <TableContainer>
            {!this.state.IsMobile && renderHeader()}
            {this.state.Tasks.map(tasksList)}
          </TableContainer>
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getTasks
})(Tasks)



// WEBPACK FOOTER //
// ./src/app/pages/Tasks/index.js